<template>
  <v-dialog v-model="show" max-width="700px" persistent scrollable>
    <v-card class="invoice-history-card">
      <div class="dialog-header">
        <div class="dialog-title-wrap">
          <div class="dialog-icon">
            <v-icon color="primary">mdi-history</v-icon>
          </div>
          <div>
            <div class="dialog-title">Invoice History</div>
            <div class="dialog-subtitle">
              {{ invoiceLabel }} change log and activity.
            </div>
          </div>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="dialog-body">
        <v-skeleton-loader v-if="loading" type="list-item-three-line@3" />

        <div v-else>
          <div v-if="!history.length" class="empty-history">
            <div class="empty-icon">
              <v-icon color="blue-grey lighten-1" size="30">mdi-history</v-icon>
            </div>
            <div class="empty-title">No history recorded</div>
            <div class="dialog-subtitle">Changes to this invoice will appear here.</div>
          </div>

          <v-timeline dense v-else class="history-timeline">
            <v-timeline-item
              v-for="h in history"
              :key="h.id"
              small
              :color="colorFor(h.action)"
            >
              <!-- Header: Action + User -->
              <div class="history-entry">
                <div class="history-heading">
                  <v-chip x-small label :color="colorFor(h.action)" dark>
                    {{ h.action }}
                  </v-chip>
                  <span class="history-user">{{ h.UserSnapshotName || "Unknown User" }}</span>
                </div>

                <div class="history-meta">
                  {{ formatDate(h.createdAt) }}
                  <span v-if="h.UserSnapshotEmail"> · {{ h.UserSnapshotEmail }}</span>
                </div>

                <div v-if="h.changesSummary" class="history-summary">
                  {{ h.changesSummary }}
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="dialog-actions">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from "../service";

export default {
  props: {
    invoice: Object,
    value: Boolean,
  },
  data() {
    return {
      show: this.value,
      history: [],
      loading: false,
    };
  },
  computed: {
    invoiceLabel() {
      return this.invoice && this.invoice.localId
        ? `Invoice #${this.invoice.localId}`
        : "Invoice";
    },
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) this.triggerLoad();
    },
    show(val) {
      this.$emit("input", val);
      if (val) this.triggerLoad();
    },
    invoice() {
      if (this.show) this.triggerLoad();
    },
  },
  methods: {
    close() {
      this.show = false;
    },

    triggerLoad() {
      this.$nextTick(() => {
        if (this.invoice?.id) {
          this.loadHistory();
        }
      });
    },

    async loadHistory() {
      this.loading = true;
      try {
        const res = await invoiceService.getHistory(this.invoice.id);
        this.history = res?.data || [];
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    formatDate(date) {
      return new Date(date).toLocaleString();
    },

    colorFor(action) {
      if (action === "CREATE") return "green";
      if (action === "UPDATE") return "blue";
      if (action === "DELETE") return "red";
      return "grey";
    },
  },
};
</script>

<style scoped>
.invoice-history-card {
  border-radius: 20px;
  overflow: hidden;
}
.dialog-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.dialog-title-wrap,
.history-heading {
  display: flex;
  align-items: center;
}
.dialog-icon,
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef4ff;
}
.dialog-icon {
  width: 42px;
  height: 42px;
  border-radius: 13px;
  margin-right: 12px;
}
.dialog-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
}
.dialog-subtitle,
.history-meta {
  font-size: 12px;
  color: #64748b;
}
.dialog-subtitle {
  margin-top: 2px;
}
.dialog-body {
  padding: 20px !important;
  background: #f8fafc;
}
.history-timeline {
  padding-top: 4px;
}
.history-entry {
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  margin-bottom: 8px;
}
.history-heading {
  gap: 9px;
}
.history-user {
  color: #334155;
  font-size: 14px;
  font-weight: 800;
}
.history-meta {
  margin-top: 5px;
}
.history-summary {
  background: #f8fafc;
  border-radius: 10px;
  color: #334155;
  font-size: 13px;
  margin-top: 10px;
  padding: 10px 12px;
  white-space: pre-wrap;
}
.empty-history {
  padding: 42px 20px;
  text-align: center;
}
.empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  margin: 0 auto 12px;
}
.empty-title {
  color: #334155;
  font-size: 16px;
  font-weight: 800;
}
.dialog-actions {
  padding: 12px 16px;
  background: #ffffff;
}
@media (max-width: 600px) {
  .dialog-body {
    padding: 12px !important;
  }
}
</style>
